
import './progressBar.css';
import React from 'react';
// import PropTypes from 'prop-types';

const ProgressBar = ( {value, total}) => {


    return (
        <div className='progress-bar-wrapper'>
            <progress className='progress-bar' value={value || 1} max={32} title={`${value}/33 questions answered`}></progress>
        </div>
    );
};



export default ProgressBar;